
import '../css/Footer.css'

console.log('css lodded')

const Footer = () => {

    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-section about">
                    <h2>About</h2>
                    <p>  I'm a passionate web developer with expertise in creating modern, responsive, and interactive web applications. Connect with me on my social media.</p>

                </div>
                <div className="footer-section links">
                    <h2>Quick Links</h2>
                    <ul>
                        <li><a href="#home">Home</a></li>
                        <li><a href="#about">About</a></li>
                        <li><a href="#projects">Projects</a></li>
                        <li><a href="#contact">Contact</a></li>
                    </ul>

                </div>
                <div className="footer-section social">
                    <h2>Follow me</h2>
                    <div className="social-icons">
                        <a href="https://github.com/Mdsaif0786" target="_blank" rel="noopener noreferrer"><i className="fab fa-github" ></i></a>
                        <a href="https://www.linkedin.com/in/md-saif-raza-99941523a/" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin" ></i></a>
                        <a href="https://www.facebook.com/mdsaifraza.raza.526" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook" ></i></a>
                        {/* <a href="https://x.com/MdsaifR10053951" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter" ></i></a> */}
                    </div>
                </div>
            </div>

            <div className="footer-botton">
                <p>&copy; {new Date().getFullYear()} Saif. All rights reserved.</p>
            </div>

        </footer>
    )
}




export default Footer